import React from 'react';
import '../../styles/windowstyles/aboutwindow.css';
import Typewriter from "typewriter-effect";
import Windows95Modal from '../shared/Windows95Modal';
import locationmarker from "../../assets/locationmarker.png";
import gradcap from "../../assets/gradcap.png"
import microsoftcomputer from "../../assets/microsoftcomputer.gif"
import resume from "../../assets/resume.pdf"

const AboutBasics = () => {
  return (
    <Windows95Modal boxWidth={1200} icon={{}}>
        <div style={{display:'flex', textAlign:'center', color:'black', width: '100%', fontFamily: 'Courier New, monospace'}}>
            <div style={{ flex: 1, position: 'relative'}}>
                <img src={locationmarker}/>
                <h3><b>Boulder, CO</b></h3>
            </div>
            <div style={{ flex: 1, position: 'relative'}}>
                <img src={gradcap}/>
                <br></br>
                <br></br>
                <h3><b>University of Houston</b></h3>
                <h6>BS, Computer Science 💻</h6>
                <h6> Minor, Mathematics 🧮</h6>
                <h6>GPA: 3.4</h6>
            </div>
            <div style={{ flex: 1, position: 'relative'}}>
                <img src={microsoftcomputer}/>
                <h3><b>Services</b></h3>
                <h6>Ground Software Systems</h6>
                <h6>Enterprise Software</h6>
                <h6>Web Development</h6>
            </div>
            <div style={{textAlign:''}}>
                <br></br>
                <br></br>
                <br></br>
                <br></br>
                <br></br>
                <br></br>
                <a href={resume}>
                    <button>Resume</button>
                </a>
            </div>
        </div>
    </Windows95Modal>
  );
};

export default AboutBasics;